import { ITranslation } from "./types";

export const de: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Vielen Dank für deinen Einkauf! Dein Kassenbon ist noch in Bearbeitung, bitte komme in einige Zeit wieder zurück! <br/>Bei Fragen oder Anregungen kontaktiere uns bittte über die Service Mail <a style="white-space: nowrap;" href="mailto:support@aifi.io">support@aifi.io</a>',
    errorReachOutSupportMsg:
      'In case of any issues, reach out for support at <a style="white-space: nowrap;" href="mailto:support@aifi.io">support@aifi.io</a>',
  },
  api: {
    E_FORCED_LOGOUT:
      "Sie wurden abgemeldet, da Ihre Verbindung abgelaufen ist.",
  },
  orderStatus: {
    draft: "Entwurf",
    contested: "Reklamiert",
    paid: "Bezahlt",
    unpaid: "Unbezahlt",
    pending: "Ausstehend",
    reviewed: "Überprüft",
    paymentProcessing: "Zahlungsabwicklung",
    refunded: "Rückerstattet",
    unknown: "Unbekannt",
  },
  receiptsList: {
    headings: {
      date: "Datum",
      time: "Zeit",
      status: "Status",
      total: "Total",
    },
    action: {
      view: "Anschauen",
    },
    statusTooltip: {
      draft: "Entwurf - Kassenbeleg wird derzeit erstellt",
      paid: "Bezahlt - Kassenbeleg wurde erstellt und Zahlung ist abgeschlossen",
      paymentProcessing:
        "Zahlungsabwicklung - Kassenbeleg wurde erstellt und Zahlungsvorgang wurde gestartet",
      unpaid:
        "Unbezahlt - Kassenbeleg wurde erstellt aber Zahlung konnte nicht erfolgreich abgeschlossen werden",
      pending:
        "Ausstehend - Kassenbeleg wurde durch Kunden reklamiert und ist derzeit beim Händler in Bearbeitung",
      reviewed:
        "Geprüft - Kassenbeleg wurde durch Kunden reklamiert und der Händler hat die Überprüfung abgeschlossen",
    },
    loadMore: "Mehr laden",
    loadingMore: "Lädt...",
    showing: "Anzeigen",
  },
  receiptDetailScreen: {
    headerTitle: "Beleg Details",
    subtotal: "Nettosumme:",
    taxBreakdown: {
      headers: {
        rate: "Steuer %",
        netto: "Netto",
        brutto: "Brutto",
        tax: "Steuer",
        total: "Gesamtbetrag:",
      },
    },
    tax: "Steuer",
    taxCRV: "CRV",
    total: "Summe:",
    processTime: "Bearbeitungszeit",
    date: "Datum",
    listOfProducts: "Artikelauflistung:",
    paymentStatus: "Zahlungsstatus:",
    orderId: "Bon-Nummer:",
  },
  receiptDetailComplain: {
    reportProblem: "Problem melden",
    submitReview: "Zur Überprüfung einsenden",
    confirmTitle: "Beleg gesendet",
    confirmButton: "Fertig",
    addMissingItem: "Produkt hinzufügen",
    addMissingItemMessage: "Eine Nachricht hinzufügen (optional)",
    form: {
      email: {
        label: "Wie können wir Sie kontaktieren?",
        placeholder: "Ihre E-Mail, z. B. me@example.com",
        errors: {
          required: "E-Mail-Adresse ist erforderlich.",
          isEmail: "Ungültige E-Mail-Adresse.",
          inUse: "E-Mail-Adresse wird bereits verwendet.",
        },
      },
    },
  },
  receiptsScreen: {
    label: {
      contested: "in Überprüfung",
      draft: "Entwurf",
      empty: "Leer",
      paid: "Bezahlt",
      pending: "Ausstehend",
      refunded: "Rückerstattet",
      reviewed: "Überarbeitet",
      unknown: "Unbekannt",
      unpaid: "Unbezahlt",
      paymentProcessing: "Zahlungsabwicklung",
    },
    message: {
      contested: "in Überprüfung Nachricht",
      draft: "Entwurf der Nachricht",
      empty: "Leere Nachricht",
      paid: "Bezahlte Nachricht",
      pending: "Ausstehende Nachricht",
      refunded: "Rückerstattungsnachricht",
      reviewed: "Überprüfte Nachricht",
      unpaid: "Unbezahlte Nachricht",
      paymentProcessing: "Zahlungsabwicklung",
    },
    minutes: "Minuten",
    hours: "Std",
    days: "Tage",
  },
  slideModal: {
    close: "Schließen",
    searchPlaceholder: "Artikel suchen",
  },
  receiptsHome: {
    receiptPortal: "Kassenbeleg-Portal",
    selectPaymentType:
      "Wähle die bevorzugte Methode, um deine Quittung zu finden.",
    cardBin:
      "Die ersten %{cardBinDigitsCount} Ziffern der Kreditkartennummer (BIN/IIN)",
    last4: "Die letzten 4 Ziffern der Kreditkartennummer",
    last4Apple: "Die letzten 4 Ziffern deiner Apple Pay-Kartenummer",
    last4Google: "Die letzten 4 Ziffern deiner Google Pay-Kartennummer",
    instructionApple:
      "So findest du die letzten 4 Ziffern deiner Apple Pay-Kartennummer im Apple Wallet",
    openWallet: "Apple Wallet öffnen",
    instructionGoogle:
      "So findest du die letzten 4 Ziffern deiner Google Pay-Kartennummer im Google Wallet",
    instructionExternalId:
      "Finden Sie die Zahlungsreferenznummer in Ihrer Zahlungs-App oder Ihrem Kontoauszug.",
    externalIdLabel: "Zahlungsreferenznummer",
    externalIdPlaceholder: "",
    expDate: "Ablaufdatum der Kreditkarte",
    visitDate: "Datum deines Besuchs",
    submit: "Quittungen zeigen",
    registerEmail:
      "Bitte gib deine E-Mail-Adresse ein, um in Kürze deinen Kassenbeleg per E-Mail zu erhalten",
    registerEmailSuccess: "E-mail Adresse ist erfolgreich registriert.",
    registerEmailFail:
      "E-mail Adress ist nicht registriert weil es leider keine Kassenbon verknüpft ist mit die eingegebene Kartennummer und/oder Einkaufsdatum.",
    unrecognizedError: "Ein unerkannter Fehler ist aufgetreten",
    inconclusiveCardInfo: "Wir können deinen Kassenbeleg nicht finden",
    optionalFieldPlaceholder: "Optional",
    invalidCaptcha: "Ungültiges Captcha, bitte versuche es erneut",
    oasisApiError:
      "Wir konnten keine Verbindung zum Kassenbeleg-Server herstellen. Bitte versuche es später erneut.",
  },
};
